import Vue from 'vue'
import './plugins/axios'
import 'lib-flexible/flexible.js'
import './style/normalize.css'
import './style/mixins.less'
import App from './App.vue'
import store from './store'
import router from './router'

const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent);

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
